import store from "@/store";

export const loginGuards = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    return next();
  }

  const roles = store.getters.roles || [];

  if (roles.includes("Admin")) {
    return next("/admin/dashboard");
  }

  if (roles.includes("Evaluator")) {
    return next("/evaluator/dashboard");
  }

  if (roles.includes("Proctor")) {
    return next("/proctor/dashboard");
  }

  if (roles.includes("Student")) {
    return next("/examine");
  }

  return next();
};

export const adminGuards = (to, from, next) => {
  const roles = store.getters.roles || [];

  if (store.getters.isAuthenticated && roles.includes("Admin")) {
    return next();
  }

  next("/");
};

export const studentGuards = (to, from, next) => {
  const roles = store.getters.roles || [];

  if (store.getters.isAuthenticated && roles.includes("Student")) {
    return next();
  }

  next("/");
};

// evaluator guards
export const evaluatorGuards = (to, from, next) => {
  const roles = store.getters.roles || [];

  if (store.getters.isAuthenticated && roles.includes("Evaluator")) {
    return next();
  }

  next("/");
};

// proctor guards
export const proctorGuards = (to, from, next) => {
  const roles = store.getters.roles || [];

  if (store.getters.isAuthenticated && roles.includes("Proctor")) {
    return next();
  }

  next("/");
};

// Exam Config guards
export const examConfigGuards = (to, from, next) => {
  const roles = store.getters.roles || [];
  if (
    store.getters.isAuthenticated &&
    (roles.includes("Admin") ||
      roles.includes("Proctor") ||
      roles.includes("Sub Admin"))
  ) {
    return next();
  }
  next("/");
};

// sub admin guards
export const subAdminGuards = (to, from, next) => {
  const roles = store.getters.roles || [];
  if (
    store.getters.isAuthenticated &&
    (roles.includes("Admin") || roles.includes("Sub Admin"))
  ) {
    return next();
  }
  next("/");
};

// configuration guards
export const configGuards = (to, from, next) => {
  const roles = store.getters.roles || [];
  if (
    store.getters.isAuthenticated &&
    (roles.includes("Admin") || roles.includes("University Team"))
  ) {
    return next();
  }
  next("/");
};
